module.exports = __webpack_public_path__ + "static/media/label.c70e61a2.svg";